import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ['Mujeres de 25 a 35 años en USA que sufren de fatiga persistente.', 'Quienes han intentado bajar de peso sin éxito debido a la inflamación.', 'Mujeres que sospechan de desequilibrios hormonales y quieren una solución natural.', 'Personas que buscan un enfoque práctico, paso a paso, para desinflamar su cuerpo.'];
  const notFor = ['Personas que buscan una solución rápida sin cambiar hábitos diarios.', 'Quienes no están dispuestos a revisar los productos que usan a diario.', 'Personas que solo quieren perder peso sin considerar su salud hormonal.', 'Quienes no creen en el impacto de los químicos ambientales en el cuerpo.'];
  return <section className="py-24 bg-white" data-id="element-185">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-186">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-187">
          {/* IS FOR */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-sage-light/30 rounded-3xl p-8 md:p-10 border border-sage-light" data-id="element-188">
            <h3 className="text-2xl md:text-3xl font-serif text-sage-dark mb-8 flex items-center" data-id="element-189">
              <span className="bg-sage text-white p-2 rounded-full mr-4" data-id="element-190">
                <Check className="w-6 h-6" data-id="element-191" />
              </span>
              Esto ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-192">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-193">
                  <Check className="w-6 h-6 text-sage shrink-0 mr-4 mt-0.5" data-id="element-194" />
                  <span className="text-dark/80 text-lg" data-id="element-195">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-50 rounded-3xl p-8 md:p-10 border border-gray-200" data-id="element-196">
            <h3 className="text-2xl md:text-3xl font-serif text-gray-600 mb-8 flex items-center" data-id="element-197">
              <span className="bg-gray-300 text-gray-600 p-2 rounded-full mr-4" data-id="element-198">
                <X className="w-6 h-6" data-id="element-199" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-200">
              {notFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-201">
                  <X className="w-6 h-6 text-gray-400 shrink-0 mr-4 mt-0.5" data-id="element-202" />
                  <span className="text-gray-600 text-lg" data-id="element-203">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}